import { cloneElement, memo } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { IconProps } from "@phosphor-icons/react";
import { Button } from "@heroui/react";

import { ICON_SIZE } from "@/config/constants";
import { LAYOUT } from "@/config/constants";
import { useBoundStore } from "@/app/store";

export interface FabMobileProps {
  icon: React.ReactElement<IconProps>;
  style?: React.CSSProperties;
  onPress?: () => void;
}

function FabMobileComponent() {
  const fab = useBoundStore((state) => state.pageLayout.fab);
  const showBottomNavigation = useBoundStore((state) => state.pageLayout.showBottomNavigation);

  const iconElement = fab
    ? cloneElement(fab.icon, {
        size: ICON_SIZE.lg,
        weight: "bold",
      })
    : null;

  const style = {
    bottom: showBottomNavigation ? LAYOUT.mobile.fab.bottomWithNav : LAYOUT.mobile.fab.bottomWithoutNav,
  };

  return (
    <AnimatePresence>
      {fab && (
        <motion.div
          initial={{ opacity: 0, scale: 0, translateY: 40, zIndex: 50 }}
          animate={{ opacity: 1, scale: 1, translateY: 0, zIndex: 50 }}
          exit={{ opacity: 0, scale: 0, translateY: 40, zIndex: 50 }}
          transition={{ duration: 0.3, ease: "easeOut" }}
          style={style}
          className="fixed right-4 flex flex-col items-center justify-center"
          layout
        >
          <Button
            className="z-50 font-semibold"
            color="primary"
            isIconOnly
            size="lg"
            radius="full"
            onPress={fab.onPress}
          >
            {iconElement}
          </Button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export const FabMobile = memo(FabMobileComponent);
